import { Pipe, PipeTransform } from '@angular/core';
import { AlarmDataSort } from '@models/alarm';

import dayjs from 'dayjs';
import { AlarmMonitoring } from 'ops/common/models/alarm-monitoring';

@Pipe({
    name: 'alarmDataFilter',
    standalone: false,
})
export class AlarmDataFilterPipe implements PipeTransform {
    transform(alarmData: AlarmMonitoring[], filterOption: IFilterOption) {
        let filteredData = [...alarmData];
        if (filterOption.category) {
            filteredData = filteredData.filter((alarm) => alarm.category === filterOption.category);
        }

        if (filterOption.value) {
            filteredData = filteredData.filter((alarm) => alarm.value === filterOption.value);
        }

        if (filterOption.occuredAt) {
            filteredData = filteredData.filter(
                (alarm) =>
                    dayjs(new Date(alarm.occurredAt)).format('DD/MM/YYYY') ===
                    filterOption.occuredAt,
            );
        }

        if (filterOption.updateAt) {
            filteredData = filteredData.filter(
                (alarm) =>
                    dayjs(new Date(alarm.updatedAt)).format('DD/MM/YYYY') === filterOption.updateAt,
            );
        }

        return filteredData;
    }
}

@Pipe({
    name: 'alarmDataSort',
    standalone: false,
})
export class AlarmDataSortPipe implements PipeTransform {
    transform(alarmData, sort: AlarmDataSort) {
        const sortedData = [...alarmData];
        if (sort === AlarmDataSort.DESC) {
            return sortedData.reverse();
        } else {
            return sortedData;
        }
    }
}

export interface IFilterOption {
    occuredAt: string;
    updateAt: string;
    value: string;
    category: string;
}
